<template>
    <div v-if="this.me">
        <h1>
        {{ me.email }}
        </h1>
    </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
    name: "TestComponent",
    apollo: {
        me: gql`query {
            me {
                email
            }
        }`
    }
}
</script>

<style scoped>

</style>
